export type { Rbac } from "./Rbac";
export { rbacRTTI } from "./rbac.rtti";
